import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { history } from 'Store';
import { showModalAction } from 'Store/modules/app/actions';
import useTranslation from 'Hooks/useTranslation';
import Arrow from 'Components/icons/Arrow';
import CustomTransition from 'Components/CustomTransition';
import { routes } from 'Constants/routes';
import { BASIC_MODAL } from 'Constants/modals';
import CustomInput from '../CustomInput';
import * as Styled from '../CustomInput/styles';
import { SatProps } from '../../types';
import UpdateSatPassword from '../UpdateSatPassword';

const DEFAULT_VALUE = '********';

const SatPassword = ({ setScreen, satValues, setSubContent }: SatProps): JSX.Element | null => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showPass, setShowPass] = useState(false);

  const handleOnChangeSatPassword = (): void => {
    dispatch(
      showModalAction({
        options: { type: BASIC_MODAL },
        Component: UpdateSatPassword,
      })
    );
  };

  return (
    <CustomTransition start>
      <Styled.BackButton
        onClick={() => {
          history.replace(routes.ACCOUNT);
          setScreen(1);
          setSubContent(true);
        }}
      >
        <Arrow />
        {t('common:BackButton')}
      </Styled.BackButton>
      <FlexContainer direction="column" id="rfcContainer" align="center">
        <FlexContainer direction="column" align="flex-start" gap="dimension_16">
          <Text type="headline" color="dark" size="S_L_S" align="start" id="fiscalData">
            {t('common:RFC.profile.title')}
          </Text>
          <Text type="paragraphs" size="S_M_S" color="dark">
            {t('common:Rfc.profile.subtitle')}
          </Text>
          {satValues?.rfcAndPassword?.rfc && (
            <CustomInput label="RFC" value={satValues?.rfcAndPassword?.rfc} />
          )}
          {satValues?.rfcAndPassword?.password && (
            <CustomInput
              label={t('common:InputPass.label')}
              value={showPass ? satValues?.rfcAndPassword.password : DEFAULT_VALUE}
              textAction={showPass ? 'common:Input.hide' : 'common:Input.show'}
              isUpdatable
              onClick={() => setShowPass(!showPass)}
            />
          )}
          <Buttons.Tiny
            mode="success"
            onClick={() => handleOnChangeSatPassword()}
            label={t('common:Update.sat.password')}
          />
        </FlexContainer>
      </FlexContainer>
    </CustomTransition>
  );
};

export default SatPassword;
